import React, { useEffect } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";

const PassVerification = ({ password, confirmPassword, setApproved }) => {
  useEffect(() => {
    if (
      lenght &&
      number &&
      upperLower &&
      sequence &&
      password === confirmPassword
    )
      return setApproved(true);
    else setApproved(false);
  }, [setApproved, password, confirmPassword]);

  const validateLength = (password) => password.length >= 8;
  const validateNumber = (password) => {
    const re = /\d/;
    return re.test(password);
  };
  const validateUpperLower = (password) => {
    const re = /(?=[a-z]+.*[A-Z]+|[A-Z].*[a-z]+)/;
    return re.test(password);
  };
  const validateSequence = (password) => {
    if (password.length == 0) return false;
    const re = /(?=0123+|1234+|2345+|3456+|4567+|5678+|6789+)/;
    return !re.test(password);
  };

  const lenght = validateLength(password);
  const number = validateNumber(password);
  const upperLower = validateUpperLower(password);
  const sequence = validateSequence(password);

  const NumberCheckbox = withStyles({
    root: {
      color: number ? "#1D3054" : "#B61817",
      "&$checked": {
        color: number ? "#1D3054" : "#B61817",
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

  const LenghtCheckbox = withStyles({
    root: {
      color: lenght ? "#1D3054" : "#B61817",
      "&$checked": {
        color: lenght ? "#1D3054" : "#B61817",
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

  const SequenceCheckbox = withStyles({
    root: {
      color: sequence ? "#1D3054" : "#B61817",
      "&$checked": {
        color: sequence ? "#1D3054" : "#B61817",
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

  const UpperLowerCheckbox = withStyles({
    root: {
      color: upperLower ? "#1D3054" : "#B61817",
      "&$checked": {
        color: upperLower ? "#1D3054" : "#B61817",
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

  return (
    <div className="centralized-column checkpassword ">
      <div className="centralized checkpassword changePassVerification">
        <div className="checkpassword__type centralized changePassVerification__type">
          <NumberCheckbox checked={number ? true : false} />

          <p style={{ color: number ? "#1D3054" : "#B61817" }}>
            Utilize <strong>caracteres numéricos;</strong>
          </p>
        </div>

        <div className="checkpassword__type centralized changePassVerification__type">
          <LenghtCheckbox checked={lenght ? true : false} />

          <div>
            <p style={{ color: lenght ? "#1D3054" : "#B61817" }}>
              Utilize no mínimo <strong>8(oito) caracteres;</strong>
            </p>
          </div>
        </div>
      </div>
      <div className="centralized checkpassword changePassVerification">
        <div className="checkpassword__type centralized changePassVerification__type">
          <SequenceCheckbox checked={sequence ? true : false} />

          <p style={{ color: sequence ? "#1D3054" : "#B61817" }}>
            <strong>Não deve seguir</strong> algum tipo de{" "}
            <strong>sequência;</strong>
          </p>
        </div>

        <div className="checkpassword__type centralized changePassVerification__type">
          <UpperLowerCheckbox checked={upperLower ? true : false} />

          <p style={{ color: upperLower ? "#1D3054" : "#B61817" }}>
            Utiliza <strong>letras maiúsculas e minúsculas;</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PassVerification;
